import { Component, EventEmitter, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ModalDeleteComponent } from 'src/app/utils/modal-delete/modal-delete.component';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { ClienteCreateComponent } from '../cliente-create/cliente-create.component';
import { ClienteUpdateComponent } from '../cliente-update/cliente-update.component';
import { ClienteViewComponent } from '../cliente-view/cliente-view.component';
import { ClienteService } from '../cliente.service';

@Component({
  selector: 'app-cliente-index',
  templateUrl: './cliente-index.component.html',
  styleUrls: ['./cliente-index.component.scss']
})
export class ClienteIndexComponent implements OnInit {

  url: string = '';
  excel: string = '';

  reloadEmitter: EventEmitter<string> = new EventEmitter();

  filtros = [
    {
      label: 'Desde',
      column: 'fecha_registro',
      op: 'gte',
      type: 'date'
    },
    {
      label: 'Hasta',
      column: 'fecha_registro',
      op: 'lte',
      type: 'date'
    },
    {
      label: 'Nombre',
      column: 'nombre',
      op: 'like',
    },
    {
      label: 'Correo Electrónico',
      column: 'email',
      op: 'like',
    },
    {
      label: 'Teléfono',
      column: 'fono',
      op: 'like',
    },
  ]

  acciones = [
    {
      label: 'Ver',
      icon: 'eye',
      action: (element: any, index: number) => {
        this.view(element)
      }
    },
    {
      label: 'Editar',
      icon: 'pen',
      action: (element: any, index: number) => {
        this.edit(element)
      }
    },
    {
      icon: "toggle-on",
      label: "Activar",
      action: (element: any, index: number) => {
        this.toggle(element);
      },
      hide: (element: any, index: number) => {
        return element.estado == 0;
      }
    },
    {
      icon: "toggle-off",
      label: "Desactivar",
      action: (element: any, index: number) => {
        this.toggle(element);
      },
      hide: (element: any, index: number) => {
        return element.estado == 1;
      }
    },
    {
      icon: "trash",
      label: "Eliminar",
      action: (element: any, index: number) => {
        this.delete(element);
      },
      hide: (element: any, index: number) => {
      }
    }
  ]

  columnas = [
    {
      label: 'Fecha',
      attribute: 'fecha_registro',
      width: 1,
      responsive: ['SM'],
      value: (element: any, index: number) => {
        return this.formatter.dateFormat(element.fecha_registro);
      }
    },
    {
      label: 'Nombre',
      attribute: 'nombre',
      width: 1,
      responsive: ['XS', 'SM', 'MD'],
      value: (element: any, index: number) => {
        return this.formatter.nombreCompleto(element);
      }
    },
    {
      label: 'Correo Electrónico',
      attribute: 'email',
      width: 1,
      responsive: ['SM', 'MD'],
      value: (element: any, index: number) => {
        return element.email;
      }
    },
    {
      label: 'Teléfono',
      attribute: 'fono',
      width: 1,
      responsive: ['MD'],
      value: (element: any, index: number) => {
        return element.fono;
      }
    },
  ]

  constructor(
    private config: ConfigService,
    private modalService: NgbModal,
    public loading: LoadingService,
    private alerts: AlertService,
    public service: ClienteService,
    public sesion: SesionService,
    public formatter: FormatterService
  ) { }

  ngOnInit(): void {
    this.url = this.config.apiUrl + this.service.controller + 'ver';
    this.excel = this.config.apiUrl + this.service.controller + 'excel';
  }

  add(): void {
    const modalRef = this.modalService.open(ClienteCreateComponent, { windowClass: 'clear-modal', size: 'lg', scrollable: true, backdrop: 'static' });
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  view(element: any): void {
    const modalRef = this.modalService.open(ClienteViewComponent, { windowClass: 'clear-modal', size: 'lg', scrollable: true });
    modalRef.componentInstance.element = element;
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  edit(element: any): void {
    const modalRef = this.modalService.open(ClienteUpdateComponent, { windowClass: 'clear-modal', size: 'lg', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.element = element;
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  toggle(element: any): void {
    if (element.estado == 0) {
      this.loading.show();
      this.service.activate(element.id).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.loadData();
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido activar el registro de cliente.", "danger");
        }
      });
      return;
    }
    if (element.estado == 1) {
      this.loading.show();
      this.service.deactivate(element.id).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.loadData();
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido desactivar el registro de cliente.", "danger");
        }
      });
    }
  }

  delete(element: any): void {
    const modalRef = this.modalService.open(ModalDeleteComponent, { windowClass: 'clear-modal', size: 'md', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Eliminar Cliente';
    modalRef.componentInstance.texto = '¿Seguro que desea eliminar este registro?';
    modalRef.componentInstance.textoAceptar = 'Eliminar';
    modalRef.result.then((result) => {
      this.loading.show();
      this.service.delete(element.id).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.loadData();
          this.alerts.addAlert("Cliente eliminado correctamente.", "success");
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido eliminar el registro de cliente.", "danger");
          if (err.error.msg) {
            this.alerts.addAlert(err.error.msg, "danger");
          }
        }
      });
    }, (reason) => { });
  }

  loadData(): void {
    this.reloadEmitter.emit();
  }
}
